import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "status" ]
  static values = { url: String, appId: String }

  connect() {
    this.requestContext()
  }

  async requestContext() {
    const encrypted = await this.encryptedUserData()
    if (!encrypted) return

    const token = document.querySelector("meta[name='csrf-token']")?.content
    const response = await fetch(this.urlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token,
        Accept: "application/json"
      },
      body: JSON.stringify({ encrypted_data: encrypted })
    })

    if (!response.ok) {
      this.show("Your CRM did not share an account with this page.")
      return
    }

    const data = await response.json()
    if (data.changed) window.location.reload()
  }

  async encryptedUserData() {
    if (typeof window.exposeSessionDetails === "function" && this.appIdValue) {
      try {
        return await window.exposeSessionDetails(this.appIdValue)
      } catch (_error) {
        // Custom pages receive the session from the parent frame instead.
      }
    }

    if (window.parent === window) return null

    return new Promise((resolve) => {
      const timer = setTimeout(() => {
        window.removeEventListener("message", onMessage)
        this.show("Your CRM did not share an account with this page.")
        resolve(null)
      }, 4000)

      const onMessage = (event) => {
        if (event.data?.message !== "REQUEST_USER_DATA_RESPONSE") return
        clearTimeout(timer)
        window.removeEventListener("message", onMessage)
        resolve(event.data.payload)
      }

      window.addEventListener("message", onMessage)
      window.parent.postMessage({ message: "REQUEST_USER_DATA" }, "*")
    })
  }

  show(message) {
    if (!this.hasStatusTarget) return
    this.statusTarget.textContent = message
  }
}
